import * as React from 'react';
import * as Header from '../constants/Header';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/admin.css';

interface MenuProps extends React.Props<{}> {
  headerActions: any;
}

class Menu extends React.Component<MenuProps, {}> {
  componentWillMount() {
    document.title = 'レポートメニュー';

    this.props.headerActions.setPage(Header.MENU);
  }   

  render() {
    return (
      <ul className="menuList">
        {/*
        <!-- // CSSで背景画像が変わる設定になってるので注意(admin.css)
        <li>
          <a href="recreation.html">
            <section>
              <h2>みんなでモフトレ</h2>
            </section>
          </a>
        </li>
        <li>
          <a href="javascript: void(0);">
            <section>
              <h2>集団体操</h2>
            </section>
          </a>
        </li>
        -->
        */}
        <li>
          <a href="user_select_literally_report" />
        </li>
        <li>
          <a href="user_select_moff_check" />
        </li>
        <li>
          <a href="user_select_locomo" />
        </li>
        <li>
          <a href="user_select_adl" />
        </li>
        <li>
          <a href="user_select_kiroku" />
        </li>
        <li>
          <a href="user_select_press" />
        </li>
        <li>
          <a href="user_interest_check" />
        </li>
        <li>
          <a href="home_visit" />
        </li>
        <style type="text/css">
          {'h1, h2 { font-weight: bold; }'}
          {'h2 { line-height: 1.75; }'}
          {'#wrapper .contentIn { width: 750px; padding: 22px 0 22px; }'}
        </style>
      </ul>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.tsx